import get from 'lodash-es/get';
import { readLocalStorage } from 'redux/saga/helpers/local-storage';
import * as logger from 'universal-logger';

let segmentCheckTimer;
let featureFlagIsLoaded = false;
let segmentEnabled = false;
let segmentCalls = {};
const segmentMethods = ['user', 'identify', 'track', 'page', 'screen', 'group', 'alias'];

export const extractSegmentUserProperties = ({
  id,
  date_of_birth: birthday,
  email,
  gender,
  last_name: lastName,
  first_name: firstName,
  username,
  created_on: createdAt,
  ...user
}) => ({
  id,
  birthday,
  phone: get(user, 'contact_info.phone'),
  email,
  gender,
  lastName,
  firstName,
  username,
  createdAt,
});

function nativeSegment() {
  if (__CLIENT__ && featureFlagIsLoaded && segmentEnabled && window.analytics) {
    return window.analytics || null;
  }
}

const segmentCall = (method, ...args) => segment => {
  try {
    if (__CLIENT__ && readLocalStorage('trackingDebug')) {
      console.info(`Tracking Segment.${method}`, ...args); // eslint-disable-line no-console
    }
    if (method === 'track') {
      const [event, properties] = args;
      return segment.track(event, {
        app_platform: 'web',
        category: event, // GA does a lot of event segmenting based on category and not event name.
        ...(properties || {}),
      });
    }
    return segment[method](...args);
  } catch (e) {
    logger.error('Segment Call Failed', e);
  }
};

function segmentCheck() {
  const segment = nativeSegment();
  if (segment) {
    clearInterval(segmentCheckTimer);
    segmentMethods
      .filter(method => segmentCalls[method] && segmentCalls[method].length > 0)
      .forEach(method =>
        segmentCalls[method].forEach(methodArguments => segmentCall(method, ...methodArguments)(segment))
      );
    segmentCalls = {};
  }
}

export const setIsFlagLoaded = value => {
  featureFlagIsLoaded = value;
};

export const setSegmentEnabled = value => {
  segmentEnabled = value;
};

const segmentInterface = segmentMethods.reduce((smInterface, method) => {
  smInterface[method] = (...args) => {
    // If it's a Server we disregard the call as it will called again when the client remounts
    // or if the feature flag returns false, we do a noop since the event won't be send to Segment.
    if (__SERVER__ || (featureFlagIsLoaded && !segmentEnabled)) {
      // Clear the interval if we are SSR or if the flag is false;
      if (segmentCheckTimer) {
        clearInterval(segmentCheckTimer);
      }
      return {};
    }
    const segment = nativeSegment();

    if (segment) {
      return segmentCall(method, ...args)(segment);
    }
    // If native Segment is not available queue call and set an interval to try
    // to call the method again later when Segment is available.
    segmentCalls[method] = segmentCalls[method] || [];
    segmentCalls[method].push(args);
    if (!segmentCheckTimer && __CLIENT__) {
      segmentCheckTimer = setInterval(segmentCheck, 500);
    }
  };
  return smInterface;
}, {});

export const segment = segmentInterface;
